import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { toast } from 'react-toastify';
import RazaoSocialService from '~/Services/RazaoSocialService';

// W-0779 — Exporta o relatório em XLSX (Q-06=A; PDF é demanda futura).
// Reenvia o mesmo payload do /relatorio; backend gera o arquivo via ClosedXML/Exportador.
const BotaoExportarExcel = ({ payload, disabled }) => {
  const [exportando, setExportando] = useState(false);

  const handleExportar = async () => {
    setExportando(true);
    try {
      await RazaoSocialService.exportarXlsx(payload);
    } catch (err) {
      // Interceptor já faz unwrap -> usar err.message.
      toast.error((err && err.message) || 'Não foi possível exportar o relatório.');
    } finally {
      setExportando(false);
    }
  };

  return (
    <Button
      variant="outline-success"
      onClick={handleExportar}
      disabled={disabled || exportando}
    >
      {exportando ? 'Exportando...' : 'Exportar Excel'}
    </Button>
  );
};

export default BotaoExportarExcel;
